import { HttpBackend, HttpClient } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { NetworkContext } from './network-context.types';

@Injectable({
  providedIn: 'root',
})
export class NetworkContextService {
  private readonly http: HttpClient;

  constructor(httpBackend: HttpBackend) {
    /*
     * HttpClient directo sobre HttpBackend.
     *
     * Esto evita los interceptores globales de la app,
     * especialmente el que agrega Authorization.
     *
     * /network-context es público y no necesita JWT.
     */
    this.http = new HttpClient(httpBackend);
  }

  getContext(): Observable<NetworkContext> {
    return this.http.get<NetworkContext>(environment.NETWORK_CONTEXT_URL);
  }
}
